import styled from 'styled-components'

import { Size, TSizeMixin } from '../styles/mixins'

export const StyledTableBody = styled.tbody<TSizeMixin & { padding?: string }>`
  ${(props: TSizeMixin) => Size({ ...props })};
  padding: ${(props) => props.padding || ''};
`
